import { autoinject, bindable, observable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { AsyncErrorHandler } from 'lib/ui';
import { GlobalAnalysisDto } from 'models/pen/GlobalAnalysis';
import { ErrorService } from 'services/error-service';

@autoinject
export class GlobalAnalysisCreateEdit {
  @bindable
  @observable
  model: GlobalAnalysisDto = new GlobalAnalysisDto();
  modelChanged(model: GlobalAnalysisDto) {
    if (!model) return;
    this.form = JSON.parse(JSON.stringify(model));
  }

  @bindable
  onSave: (data: { data: GlobalAnalysisDto }) => void;

  @bindable
  onCanceled: () => void;

  @bindable
  visible = false;

  protected form: GlobalAnalysisDto = new GlobalAnalysisDto();

  constructor(
    private errorService: ErrorService,
    private validationController: ValidationController,
    private validator: Validator,
    private t: I18N
  ) {}

  protected applyValidationRules() {
    ValidationRules.ensure('AnalysisNo')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Name')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Version')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Author')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .ensure('Date')
      .required()
      .withMessage(this.t.tr('general.requiredField'))
      .on(this.form);
  }

  attached() {
    this.applyValidationRules();
  }

  private async validate() {
    this.applyValidationRules();
    await this.validator.validateObject(this.form);
    return (await this.validationController.validate({ object: this.form })).valid;
  }

  @AsyncErrorHandler
  async save() {
    const valid = await this.validate();
    if (!valid) return;
    this.onSave({ data: this.form });
  }

  cancel() {
    this.onCanceled?.();
  }
}
